import { cva } from 'class-variance-authority'
import clsx from 'clsx'
import React from 'react'

const chipCVA = cva(
  'si-chip',
  {
    variants: {
      variant: {
        points: 'si-icon--leading',
        timeUp: 'si-time-up',
      }
    },
  })

const Chip = ({ variant, icon, children }) => {
  return (
    <>
      <div className={clsx(chipCVA({ variant }))}>
        {/* add this icon for streak only */}
        <i className={icon}></i>
        <span>{children}</span>
      </div>
    </>
  )
}

export { Chip }
